<template>
  <div id="News">
    <TopCover />
    <List :news_data="news_data" />
  </div>
</template>

<script>
import TopCover from "@/components/News/TopCover"
import List from "@/components/News/List"
export default {
  name: "News",
  components: {
    TopCover,
    List
  },
  data() {
    return {
      news_data: []
    }
  },
  methods: {
    async GetNewsoData() {
      let result = await this.SendGetData(process.env.VUE_APP_BASE_API + 'news/get_news_list.php')
      if (result != "error") {
        console.log()
        this.news_data = JSON.parse(result.data)
      }
    }
  },
  created() {
    this.GetNewsoData()
  }
}
</script>